import { Input as InputPrimitive } from "@base-ui/react/input";
import { cn } from "@maker/utils/cn";

type InputProps = React.ComponentProps<"input">;

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
	return (
		<InputPrimitive
			type={type}
			data-slot="input"
			className={cn(
				"h-8 w-full min-w-0 rounded border border-neutral-200 bg-white px-2 py-1.25 text-sm outline-none file:inline-flex file:border-0 file:font-medium placeholder:text-neutral-500 focus-visible:border-blue-600 focus-visible:ring-1 focus-visible:ring-blue-600 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:opacity-50 aria-invalid:border-red-500 aria-invalid:ring-2 aria-invalid:ring-red-500",
				className,
			)}
			{...props}
		/>
	);
}

export { Input, type InputProps };
